import { dynamicNamespace } from 'utils/dynamic';
import { apiRtk, transformResponseDynamic } from 'utils/service';
import { API_DIET_DIARY_TYPES, DietDiaryTypeSourceItem } from './models';
const dynamic = dynamicNamespace<Components.Schemas.DietDiaryType>();

export const apiDietDiaryTypes = apiRtk.injectEndpoints({
  endpoints: (build) => {
    return {
      getSourceDietDiaryTypes: build.query<DietDiaryTypeSourceItem[], void>({
        query: () => ({
          url: API_DIET_DIARY_TYPES.GET_ALL_DYNAMIC,
          params: {
            select: dynamic.select('id', 'title', 'icon', 'color', 'rowIndex'),
            orderBy: 'rank asc',
          },
        }),
        transformResponse: transformResponseDynamic,
      }),
    };
  },
});
